(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name tracker.factory:Tracker
   *
   * @description
   *
   */
  angular
    .module('vctracker')
    .factory('Tracker', Tracker);
  
  
  Tracker.$inject = ['restmod'];
  function Tracker(restmod) {
    return restmod.model('/routes/trackers').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/trackers/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            return $search({key, val});
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
